import { FloatingNotification, type FloatingNotificationProps } from "apps/commons/components/FloatingNotification";
import type { FunctionComponent } from "react";
import { useStaticDataAtomValue } from "../staticDataAtom";

export const DeleteSuccessfulNotification: FunctionComponent<Pick<FloatingNotificationProps, "visible" | "onClose">> = (
    props,
) => {
    const {
        cmsData: {
            photo: { successfulDeletion, photoDeletedSuccessfully },
        },
    } = useStaticDataAtomValue();

    return (
        <FloatingNotification
            intent="positive"
            icon="fill.symbol.circle-check"
            title={successfulDeletion}
            description={photoDeletedSuccessfully}
            {...props}
        />
    );
};
